import React from "react";
import { DetailSidePanel } from "../DetailSidePanel";
import { SidePanelDeleteEntryButton } from "../SidePanelDeleteEntryButton";
import { emptyListFunc } from "components/MainSectionTemplate/emptySubmitChangeFunc";
import { AccessTypeSidePanelDetails } from "./AccessTypeSidePanelDetails";

interface AccessTypeSidePanelProps {
  accessType: server.dto.GuestlistAccessType;
  trigger: JSX.Element
}

export const AccessTypeSidePanel = (props: AccessTypeSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => emptyListFunc()}
    apiKey="guestlistAccessType"
    entityId={props.accessType.guestlistAccessTypeId}
    title={RESX.Guestlist.AccessType}
    trigger={props.trigger}
    footerContent={<>
      <SidePanelDeleteEntryButton
        apiCall={() => window.CoreApi.Guestlist.DeleteGuestlistAccessType({ guestlistAccessTypeId: props.accessType.guestlistAccessTypeId }, { toastOnError: true })}
      />
    </>}
  >
    {() => <AccessTypeSidePanelDetails accessType={props.accessType} />}
  </DetailSidePanel>;
};